import type { RouteType } from "../directions/types";
import type {
  RouteIndication,
  RouteSegment,
  RouteStep,
} from "../navigation/types";

export type IGraphJS = {
  setPois: (poisJson: string) => void;
  setFences: (fencesJson: string) => void;
  distancesToPois: (
    origin: string,
    config: string,
    poiIds: string,
    thresholdPoiDistances: number,
  ) => string;
  jsonFactory: (
    pathsJson: string,
    buildingInfo: string,
    distanceBetweenFloors?: number | null,
  ) => void;
  shortestPath: (origin: string, destination: string, config: string) => string;
  calculateIndications: (
    route: string,
    indicationsParameters?: string | null,
  ) => string;
  updateRouteIndications: (
    floorId: number,
    x: number,
    y: number,
    bearing: number,
    hasBearing: boolean,
  ) => string;
  setNavigationParameters: (navigationParameters: string) => void;
  whereAmI: (
    floorId: number,
    x: number,
    y: number,
    bearing: number,
    buildingRotation: number,
    routeConfiguration: string,
    thresholdPoiDistances: number,
  ) => string;
};

export type IDistanceResult = {
  id: string;
  distance: number | null;
};

export type IPartialRoute = {
  steps: RouteStep[];
  segments: RouteSegment[];
  indications: RouteIndication[];
  type: RouteType;
};

export type WorkerResult<T> = {
  messageId: string;
  payload: T & { error?: string };
};

export enum WORKER_EVENTS {
  INIT = "worker.routes.init",
  DISTANCES = "worker.routes.distances",
  DIRECTIONS = "worker.routes.directions",
  NAVIGATION = "worker.routes.navigation",
  NAVIGATION_PARAMETERS = "worker.routes.navigation_parameters",
  WHERE_AM_I = "worker.routes.where_am_i",
}
